<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="addProject"
    size="sm"
    ref="addProject"
    body-class="bg-white"
    cancel-title="Close"
    cancel-variant="light"
    :ok-title-html="pjt_id.pjt_id!=''?submitted==true?loaderIcon+'Update':'Update':submitted==true?loaderIcon+'Save':'Save'"
    :title="pjt_id.pjt_id != '' ? 'Edit Project' : 'Add Project'"
    @ok="handleProject"
    @shown="pjt.pjt_id = pjt_id.pjt_id,pjt.pjt_name = pjt_id.pjt_name"
    :ok-disabled="submitted"
  >
    <b-form @submit.stop.prevent="addpjt_form" id="addpjt_form">
      <b-form-group>
        <b-row>
          <b-col lg="12">
            <label for="pjt_name" class="required">Project Name</label>
            <b-form-input
              v-validate="'max:100'"
              id="pjt_name"
              type="text"
              v-model.trim="pjt.pjt_name"
              name="pjt_name"
              placeholder
            />
            <span
              class="text-danger"
              v-if="errors.has('pjt_name')"
            >Project name contain maximum 100 characters</span>
            <input type="hidden" name="pjt_id" :value="pjt_id.pjt_id" />
          </b-col>
        </b-row>
      </b-form-group>
    </b-form>
  </b-modal>
</template>
<script>
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
export default {
  mixins: [notificationMixin],
  props: ["pjt_id"],
  data() {
    return {
      loaderIcon: '<i class="fa fa-circle-o-notch fa-spin mr-2"></i>',
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      pjt: {
        pjt_name: ""
      }
    };
  },

  methods: {
    handleProject(evt) {
      // Prevent modal from closing
      evt.preventDefault();
      if (this.pjt.pjt_name == "" || this.pjt.pjt_name.length > 100) {
        var message =
          this.pjt.pjt_name == ""
            ? "Project name should not be empty"
            : "Project name(100) exceeds maximum length";
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: message,
          type: "danger",
          showCloseButton: true
        });
      } else {
        this.submitted = true;

        let myForm = document.getElementById("addpjt_form");
        let formData = new FormData(myForm);
        store.dispatch("sales/addProject", formData).then(response => {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: response.data.status,
            type: response.status == 200 ? "success" : "danger",
            showCloseButton: true
          });
          this.submitted = false;
           this.$emit("setAddedRefproject", this.pjt);
          if (response.status == 200) {
            this.$refs.addProject.hide();
           
          }
        });
      }
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  }
};
</script>
<style>
.required:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>